import get from 'lodash/get';
// @dynamic-i18n-keys
// groups.invite.popup.form.errors.*
// common.formError.*
import { useTranslation } from 'react-i18next';
import { useId } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import SharedSelectField from '@wix/da-ds/pkg/Dropdown/select/SelectField';

function SelectField({ name, label, defaultValue = '', items = [], ...props }) {
  const id = useId();
  const { t } = useTranslation();
  const { control, errors } = useFormContext();
  const error = get(errors, name);

  const {
    field: { ref, onChange, ...inputProps },
  } = useController({
    name,
    control,
    defaultValue,
  });

  return (
    <SharedSelectField
      id={id}
      label={label}
      items={items}
      onSelect={(value: string, event: any) => onChange(event)}
      error={error && t(error?.message)}
      {...props}
      {...inputProps}
    />
  );
}

export default SelectField;
